import { CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';
import Masonry from '@mui/lab/Masonry';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { Button, Form, Modal, Select } from 'antd';
import Cookies from 'js-cookie';
import { useCallback, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
// import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import { useHistory, useLocation as x } from 'react-router-dom';

import { articlesService } from 'config/services';

import { HttpError } from 'helpers/http';

import { PaginationParams } from 'types/common';
import { ObituaryOptions, PaginatedObituaries } from 'types/services/obituary';

import { citiesList as cities } from '../../assets/cities';

import { Footer } from './Footer';
import { Header } from './Header';
import { SingleObituary } from './SingleObituary';
import tCode from './transactionCode.json';

import './styles.css';

export const FrontView = (props?: any) => {
  const [pagination, setPagination] = useState<PaginationParams>(
    props.perPage ? { page: 1, perPage: props.perPage } : { page: 1, perPage: 1000 },
  );
  let url = new URL(window.location.href);
  let params = new URLSearchParams(url.search).getAll('q');
  let paramFilter = new URLSearchParams(url.search).getAll('tip');

  let transactionCode = new URLSearchParams(url.search).getAll('trnCode');
  let uuid = new URLSearchParams(url.search).getAll('uuid');
  let city = new URLSearchParams(url.search).getAll('lokacija');
  let date = new URLSearchParams(url.search).getAll('datum');
  let type = new URLSearchParams(url.search).getAll('tip');
  const [failedTransactionMessage, setFailedTransactionMessage] = useState(false);
  const [msgShow, setMsgShow] = useState(false);
  const [form] = Form.useForm();

  const history = useHistory();

  const [citiesListNew, setCitiesList] = useState<any[]>(['Svi', ...cities]);

  /* let findCityOne = citiesListNew.find((i) => String(i) === String(city));
  console.log(typeof findCityOne, findCityOne === 'Sarajevo', 'typeof'); */

  const cityTemp = city[0] ? city[0].replace('-', ' ') : '';
  let findCity = citiesListNew.find((i) => String(i) === String(cityTemp));
  const [location, setLocation] = useState(findCity ? findCity : '');

  useEffect(() => {
    /* form.setFieldsValue({
      city: findCity ? findCity : 'Svi',
    }); */

    setLocation(findCity ? findCity : 'Svi');

    if (date.length > 0) {
      setDate1(date[0] as string);
    }

    const tempType = type[0] ? type[0] : '';
    const typesNumber: any = {
      umrli: 1,
      sjecanja: 2,
      sucuti: 3,
    };

    const paramType = typesNumber[tempType] ? typesNumber[tempType] : '';

    setObituaryType(paramType as string);

    //console.log({ ...filters, city: findCity as string, date: date[0] as string }, 'prvi use Effect');

    if (date || findCity || type) {
      setFilters({ ...filters, city: findCity as string, date: date[0] as string });
    }
  }, []);

  const cityOnChange = (e: any) => {
    setLocation(e);
    createUrlHistory({ datum: date1, obituaryType, city: e as string });
  };

  const [obituaryType, setObituaryType] = useState(type.length > 0 ? (type[0] as string) : '');

  const [msg, setMsg] = useState('');
  const cookie = Cookies.get('uuid');

  const [selectOpen, setSelectOpen] = useState(false);

  const newDate = new Date();
  const newDateString = newDate.toISOString().replace('T', ' ').substring(0, 10);

  const modifiedDateString =
    date.length > 0
      ? date[0]
      : newDateString.slice(8, 10) + '.' + newDateString.slice(5, 7) + '.' + newDateString.slice(0, 4);
  const [date1, setDate1] = useState(modifiedDateString);

  const [mondayDate1, setMondayDate1] = useState(
    new Date(
      Number(String(date1).slice(6, 10)),
      Number(String(date1).slice(3, 5)) - 1,
      Number(String(date1).slice(0, 2)),
    ),
  );

  const [mondayDate1Plus, setMondayDate1Plus] = useState(
    new Date(
      Number(String(date1).slice(6, 10)),
      Number(String(date1).slice(3, 5)),
      Number(String(date1).slice(0, 2)) + 1,
    ),
  );

  const currentDate = newDateString.slice(8, 10) + '.' + newDateString.slice(5, 7) + '.' + newDateString.slice(0, 4);

  const todaysDate = currentDate;

  const [filters, setFilters] = useState<ObituaryOptions>(
    params.length > 0
      ? { search: params[0] }
      : paramFilter.length > 0 && paramFilter[0] === 'umrli'
      ? { date: date1, city: location, obituaryType: '1' }
      : paramFilter.length > 0 && paramFilter[0] === 'sjecanja'
      ? { date: date1, city: location, obituaryType: '2' }
      : paramFilter.length > 0 && paramFilter[0] === 'sucuti'
      ? { date: date1, city: location, obituaryType: '3' }
      : { date: date1, city: location, obituaryType: obituaryType },
  );

  useEffect(() => {
    //console.log(location, 'location in date1 effect');
    setFilters({ ...filters, date: date1, city: location, obituaryType });
  }, [date1]);

  /* useEffect(() => {
    console.log(location, 'location in date1 effect');
    console.log(filters, 'useEffect filters');
  }, [filters]); */

  useEffect(() => {
    if (uuid && uuid.length > 0 && transactionCode[0] === '000') {
      Cookies.remove('uuid');
    } else if (uuid && uuid.length > 0 && transactionCode[0] !== '000') {
      setFailedTransactionMessage(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uuid]);

  useEffect(() => {
    if (cookie) {
      setMsgShow(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    Object.keys(tCode).forEach((t) => {
      if (t === transactionCode[0]) {
        setMsg(tCode[t as keyof typeof tCode]);
      }
    });
  }, [transactionCode]);

  useEffect(() => {
    if (msg !== '' && !msgShow) {
      // if (transactionCode[0] === '000') {
      //   message.success(msg);
      // } else {
      //   message.error(msg);
      // }
      setMsgShow(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [msg]);

  const IconArrow = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={'16'}
      height={'16'}
      x="0"
      y="0"
      viewBox="0 0 128 128"
      xmlSpace="preserve"
      stroke="currentColor"
      id="Right_Arrow_4_Svg"
    >
      <g>
        <path
          id="Right_Arrow_4_"
          d="m44 108c-1.023 0-2.047-.391-2.828-1.172-1.563-1.563-1.563-4.094 0-5.656l37.172-37.172-37.172-37.172c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0l40 40c1.563 1.563 1.563 4.094 0 5.656l-40 40c-.781.781-1.805 1.172-2.828 1.172z"
          data-original="#000000"
          style={{ fill: '#000' }}
        />
      </g>
    </svg>
  );

  const Filter = ({ classNames = 'sWH' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="filter">
      <path
        fill="#333333"
        fill-rule="evenodd"
        d="M20 5h-1.17a3.001 3.001 0 0 0-5.66 0H4a1 1 0 0 0 0 2h9.17a3.001 3.001 0 0 0 5.66 0H20a1 1 0 1 0 0-2zm-4 2a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM3 12a1 1 0 0 1 1-1h1.17a3.001 3.001 0 0 1 5.66 0H20a1 1 0 1 1 0 2h-9.17a3.001 3.001 0 0 1-5.66 0H4a1 1 0 0 1-1-1zm5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-4 4a1 1 0 1 0 0 2h9.17a3.001 3.001 0 0 0 5.66 0H20a1 1 0 1 0 0-2h-1.17a3.001 3.001 0 0 0-5.66 0H4zm13 1a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
        clip-rule="evenodd"
      ></path>
    </svg>
  );

  const {
    data: response,
    isLoading,
    refetch,
  } = useQuery<PaginatedObituaries, HttpError>(['listObituaries'], () => {
    return articlesService.listFrontObituaries(pagination, filters);
  });

  const useMediaQuery = (width: number) => {
    const [targetReached, setTargetReached] = useState(false);

    const updateTarget = useCallback((e) => {
      if (e.matches) {
        setTargetReached(true);
      } else {
        setTargetReached(false);
      }
    }, []);

    useEffect(() => {
      const media = window.matchMedia(`(max-width: ${width}px)`);
      media.addEventListener('change', updateTarget);
      // Check on mount (callback is not called until a change occurs)
      if (media.matches) {
        setTargetReached(true);
      }

      return () => media.removeEventListener('change', updateTarget);
    }, []);

    return targetReached;
  };

  const isBreakpoint = useMediaQuery(768);

  const createUrlHistory = (data?: any) => {
    //date: date1, city: location, obituaryType: obituaryType
    let url = '';
    let grad = data.city && data.city !== 'Svi' ? 'lokacija=' + data.city.replace(' ', '-') : '';
    let date = data.datum ? 'datum=' + data.datum : '';

    //console.log(data.obituaryType, 'data.obituaryType');

    const types: any = {
      1: 'umrli',
      2: 'sjecanja',
      3: 'sucuti',
    };

    let sufix = types[data.obituaryType] ? types[data.obituaryType] : '';

    //console.log('sufix=' + sufix + '|', data.obituaryType);

    //if (data.obituaryType) console.log('postoji');

    let tip = data.obituaryType ? 'tip=' + sufix : '';

    //console.log('tip', tip);

    if (grad || date || tip) url = '?';

    let full = [grad, date, tip].filter((i: string) => i.length > 0).join('&');

    url += full;

    //console.log(url, 'url');

    history.push(url, Math.random().toString());
    window.location.href = url;
    return url;
  };

  const [filterValue, setFilterValue] = useState('');
  useEffect(() => {
    const handlePopstate = () => {
      /* const queryParams = new URLSearchParams(window.location.search);
      const newFilterValue = queryParams.get('filter') || '';
      setFilterValue(newFilterValue); */
      window.location.reload();
    };
    window.addEventListener('popstate', handlePopstate);
    return () => {
      window.removeEventListener('popstate', handlePopstate);
    };
  }, []);

  const handleFilterChange = (event: any) => {
    const newFilterValue = event.target.value;
    setFilterValue(newFilterValue);
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('datum', newFilterValue);
    const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
    window.history.pushState(null, '', newUrl);
  };

  useEffect(() => {
    // Simulating an API call to fetch the selected value
    const fetchSelectedValue = async () => {
      const cityTemp = city[0] ? city[0].replace('-', ' ') : '';
      let findCity = citiesListNew.find((i) => String(i) === String(cityTemp));
      if (findCity) {
        form.setFieldsValue({
          city: findCity ? findCity : 'Svi',
        });
      }
    };

    fetchSelectedValue();
  }, [response]);

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(0.5),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    boxShadow: 'none',
  }));

  return (
    <div>
      <Header></Header>
      <div className="buttons-navigation">
        <Button
          type="text"
          id="allObituaries"
          className={`allObituaries ${obituaryType === '' || !obituaryType ? 'activeTab' : ''}`}
          onClick={() => {
            setPagination({ page: 1, perPage: 1000 });
            createUrlHistory({ datum: '', obituaryType: '', city: '' });
          }}
        >
          SVE
        </Button>
        <Button
          type="text"
          className={`deathObituaries ${Number(obituaryType) === 1 ? 'activeTab' : ''}`}
          id="deathObituaries"
          onClick={() => {
            setPagination({ page: 1, perPage: 1000 });
            createUrlHistory({ datum: '', obituaryType: '1', city: '' });
          }}
        >
          UMRLI
        </Button>
        <Button
          type="text"
          className={`remeberingObituaries ${Number(obituaryType) === 2 ? 'activeTab' : ''}`}
          id="remeberingObituaries"
          onClick={() => {
            setPagination({ page: 1, perPage: 1000 });
            createUrlHistory({ datum: '', obituaryType: '2', city: '' });
          }}
        >
          SJEĆANJA
        </Button>
        <Button
          type="text"
          className={`lastgoodbye ${Number(obituaryType) === 3 ? 'activeTab' : ''}`}
          id="lastgoodbye"
          onClick={() => {
            setPagination({ page: 1, perPage: 1000 });
            createUrlHistory({ datum: '', obituaryType: '3', city: '' });
          }}
        >
          SUĆUTI
        </Button>

        {/*  <button
          onClick={() => {
            console.log(obituaryType, 'obituaryType');
            console.log(obituaryType === '1', typeof obituaryType);
            console.log(date1, 'date1');
            //console.log(date1, todaysDate, date1 !== todaysDate);
          }}
        >
          EVOOO
        </button>
 */}
        {isBreakpoint && (
          <Button className="listItem small-obituary-create" href={'/objavi'}>
            <span id="publish-obituary-mobile">OBJAVITE SMRTOVNICU</span>
          </Button>
        )}
      </div>
      <div className="mainFrontContainer">
        <div className="mobileFilter">
          <h1
            className="filterDateText"
            style={{
              marginLeft: 'auto',
              marginRight: 'auto',
              fontFamily: 'DMSans,sans-serif',
              fontWeight: 700,
              color: '#333',
            }}
          >
            {date1 === '29.02.2024'
              ? '29.02.2024. / 01.03.2024.'
              : date1 === '09.04.2024'
              ? '09.04.2024. / 10.04.2024.'
              : date1 === '30.04.2024'
              ? '30.04.2024. / 01.05.2024. / 02.05.2024.'
              : date1 === '15.06.2024'
              ? '15.06.2024. / 16.06.2024. / 17.06.2024.'
              : date1 === '23.11.2024'
              ? '23.11.2024. / 24.11.2024. / 25.11.2024.'
              : date1 === '31.12.2024'
              ? '31.12.2024. / 01.01.2025. / 02.01.2025.'
              : date1 === '28.02.2025'
              ? '28.02.2025. / 01.03.2025. / 02.03.2025.'
              : date1 === '29.03.2025'
              ? '29.03.2025. / 30.03.2025. / 31.03.2025.'
              : date1 === '30.04.2025'
              ? '30.04.2025. / 01.05.2025. / 02.05.2025.'
              : date1 === '05.06.2025'
              ? '05.06.2025. / 06.06.2025.'
              : mondayDate1.getDay() === 6
              ? date1 +
                '. / ' +
                mondayDate1Plus.getDate().toString().padStart(2, '0') +
                '.' +
                mondayDate1Plus.getMonth().toString().padStart(2, '0') +
                '.' +
                mondayDate1Plus.getFullYear() +
                '.'
              : date1 + '.'}
          </h1>
          <div className="divider" style={{ marginLeft: '6px' }}>
            <span></span>
          </div>
          <div className="filterButtonDiv">
            <button
              onClick={() => {
                let selectForm = document.getElementById('selectForm');
                selectForm?.classList.add('noWidthForm');
                let open = document.getElementsByClassName('form-city-date');
                if (!open[0].classList.contains('openFilter')) {
                  open[0].classList.add('openFilter');
                } else {
                  open[0].classList.remove('openFilter');
                }
                setSelectOpen(!selectOpen);

                const firstChildElement = selectForm?.firstElementChild;
                firstChildElement?.classList.add('selectPosition');
              }}
              className="filterButton"
              style={{ width: '32px', height: '32px' }}
            >
              <Filter />
            </button>
          </div>
          <Form
            form={form}
            style={{
              justifyContent: 'flex-end',
              alignItems: 'center',
              marginBottom: '20px',
              marginLeft: 'auto',
            }}
            className="form-city-date"
            id="selectForm"
          >
            <Form.Item
              name={'city'}
              style={{ width: '170px', float: 'right', marginBottom: '0px' }}
              className="textType"
            >
              <Select
                id="selectS"
                onClick={() => setSelectOpen(!selectOpen)}
                open={selectOpen}
                onChange={cityOnChange}
                showSearch
                placeholder={'Odaberite lokaciju'}
                options={Object.values(citiesListNew).map((type: any) => ({
                  label: type,
                  value: type,
                }))}
              />
            </Form.Item>
          </Form>
        </div>
        {response && response.data.length > 0 && !isLoading ? (
          <Box>
            <Masonry className="containerSingleMobile" columns={{ xs: 1, md: 2, lg: 3 }} spacing={3}>
              {response?.data.map((OBI, index) => (
                <Item key={index}>
                  <SingleObituary singleObituary={OBI}></SingleObituary>
                </Item>
              ))}
            </Masonry>
          </Box>
        ) : !isLoading && params.length > 0 ? (
          <div className="noResultsContainer">
            <h3 className="noResultsText">Nema rezultata za traženi pojam: {params[0]}</h3>
          </div>
        ) : !isLoading ? (
          <div className="noResultsContainer" style={{ marginTop: '40px' }}>
            <h3 className="noResultsText" style={{ color: '#333' }}>
              Nema rezultata
            </h3>
          </div>
        ) : (
          <></>
        )}
        <div className="pagination-style">
          {date1 !== todaysDate && (
            <Button
              className="rotate"
              style={{ width: '148px', height: '40px', padding: '0px 15px', borderColor: '#e3e3e3' }}
              onClick={() => {
                const newDate = new Date(
                  Number(String(date1).slice(6, 10)),
                  Number(String(date1).slice(3, 5)) - 1,
                  Number(String(date1).slice(0, 2)) + 2,
                );
                const newDateString = newDate.toISOString().replace('T', ' ').substring(0, 10);
                const modifiedDateString =
                  newDateString.slice(8, 10) + '.' + newDateString.slice(5, 7) + '.' + newDateString.slice(0, 4);

                let newModifiedDateTime = new Date(
                  Number(String(modifiedDateString).slice(6, 10)),
                  Number(String(modifiedDateString).slice(3, 5)) - 1,
                  Number(String(modifiedDateString).slice(0, 2)),
                );

                let mondayModified = new Date(
                  Number(String(modifiedDateString).slice(6, 10)),
                  Number(String(modifiedDateString).slice(3, 5)) - 1,
                  Number(String(modifiedDateString).slice(0, 2)) + 2,
                );

                const newDateStringMonday = mondayModified.toISOString().replace('T', ' ').substring(0, 10);
                const modifiedDateStringMonday =
                  newDateStringMonday.slice(8, 10) +
                  '.' +
                  newDateStringMonday.slice(5, 7) +
                  '.' +
                  newDateStringMonday.slice(0, 4);

                createUrlHistory({
                  datum:
                    modifiedDateString === '01.03.2024'
                      ? '02.03.2024'
                      : modifiedDateString === '10.04.2024'
                      ? '11.04.2024'
                      : modifiedDateString === '01.05.2024'
                      ? '03.05.2024'
                      : modifiedDateString === '16.06.2024'
                      ? '18.06.2024'
                      : modifiedDateString === '24.11.2024'
                      ? '26.11.2024'
                      : modifiedDateString === '01.01.2025'
                      ? '03.01.2025'
                      : modifiedDateString === '01.03.2025'
                      ? '03.03.2025'
                      : modifiedDateString === '30.03.2025'
                      ? '01.04.2025'
                      : modifiedDateString === '06.06.2025'
                      ? '07.06.2025'
                      : modifiedDateString === '01.05.2025' || modifiedDateString === '02.05.2025'
                      ? '03.05.2025'
                      : newModifiedDateTime.getDay() === 0
                      ? modifiedDateStringMonday
                      : modifiedDateString,
                  obituaryType,
                  city: location,
                });
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
            >
              <span className="prevSpan prevSpanRotate" style={{ fontSize: '16px' }}>
                Sljedeći dan
              </span>
              <IconArrow></IconArrow>
            </Button>
          )}

          {response && (
            <Button
              onClick={() => {
                const newDate = new Date(
                  Number(String(date1).slice(6, 10)),
                  Number(String(date1).slice(3, 5)) - 1,
                  Number(String(date1).slice(0, 2)),
                );
                const newDateString = newDate.toISOString().replace('T', ' ').substring(0, 10);
                const modifiedDateString =
                  newDateString.slice(8, 10) + '.' + newDateString.slice(5, 7) + '.' + newDateString.slice(0, 4);

                let newModifiedDateTime = new Date(
                  Number(String(modifiedDateString).slice(6, 10)),
                  Number(String(modifiedDateString).slice(3, 5)) - 1,
                  Number(String(modifiedDateString).slice(0, 2)),
                );

                let mondayModified = new Date(
                  Number(String(modifiedDateString).slice(6, 10)),
                  Number(String(modifiedDateString).slice(3, 5)) - 1,
                  Number(String(modifiedDateString).slice(0, 2)),
                );

                const newDateStringMonday = mondayModified.toISOString().replace('T', ' ').substring(0, 10);
                const modifiedDateStringMonday =
                  newDateStringMonday.slice(8, 10) +
                  '.' +
                  newDateStringMonday.slice(5, 7) +
                  '.' +
                  newDateStringMonday.slice(0, 4);

                createUrlHistory({
                  datum:
                    modifiedDateString === '01.03.2024'
                      ? '29.02.2024'
                      : modifiedDateString === '10.04.2024'
                      ? '09.04.2024'
                      : modifiedDateString === '02.05.2024'
                      ? '30.04.2024'
                      : modifiedDateString === '17.06.2024'
                      ? '15.06.2024'
                      : modifiedDateString === '25.11.2024'
                      ? '23.11.2024'
                      : modifiedDateString === '02.01.2025'
                      ? '31.12.2024'
                      : modifiedDateString === '02.03.2025'
                      ? '28.02.2025'
                      : modifiedDateString === '01.03.2025'
                      ? '28.02.2025'
                      : modifiedDateString === '06.06.2025'
                      ? '05.06.2025'
                      : modifiedDateString === '31.03.2025' || modifiedDateString === '30.03.2025'
                      ? '29.03.2025'
                      : modifiedDateString === '01.05.2025' || modifiedDateString === '02.05.2025'
                      ? '30.04.2025'
                      : newModifiedDateTime.getDay() === 0
                      ? modifiedDateStringMonday
                      : modifiedDateString,
                  obituaryType,
                  city: location,
                });
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              style={{
                marginLeft: 'auto',
                width: '162px',
                height: '40px',
                padding: '0px 15px',
                borderColor: '#e3e3e3',
              }}
              className="styleMobileArrow"
            >
              <span className="prevSpan nextSpanRotate" style={{ fontSize: '16px' }}>
                Prethodni dan
              </span>
              <IconArrow></IconArrow>
            </Button>
          )}
        </div>
      </div>
      <Footer></Footer>

      <Modal
        title="Obavijest"
        centered
        width={350}
        visible={msgShow}
        onOk={() => {
          setMsgShow(false);
          if (msg === 'Transakcija uspješna') {
            window.location.href = `/`;
          } else {
            window.location.href = `/placanje/${Cookies.get('uuid') ? Cookies.get('uuid') : uuid}`;
          }
        }}
        onCancel={() => {
          setMsgShow(false);
          Cookies.remove('uuid');
        }}
        okText={msg === 'Transakcija uspješna' ? 'Ok' : 'Pokušaj uplatu ponovo'}
        cancelButtonProps={
          msg === 'Transakcija uspješna' ? { style: { display: 'none' } } : { style: { display: 'unset' } }
        }
      >
        <br></br>
        <br></br>
        <div className="modalMsg">
          {msg === 'Transakcija uspješna' ? (
            <CheckCircleTwoTone twoToneColor={'lightgreen'} style={{ fontSize: '40px' }} />
          ) : (
            <CloseCircleTwoTone twoToneColor={'red'} style={{ fontSize: '40px' }} />
          )}
          <p>{msg}</p>
          {failedTransactionMessage || (cookie && <p>Imate nedovršenih transakcija</p>)}
        </div>
        <br></br>
        <br></br>
      </Modal>
    </div>
  );
};
